import { BlockedRecordBlockedScope } from '@exam-center/graphql';

import {
  type BlockedRecordExamCenterManagerFormInput,
  type BlockedRecordExamPasserFormType,
  type BlockedRecord,
  type BlockedRecordProctorFormInput,
  type BlockedRecordStaffFormInput,
  type BlockedRecordCheaterFormType,
} from '../providers';

export function getProctorDefaultValues(input: {
  blockedRecord: BlockedRecord;
}): BlockedRecordProctorFormInput {
  const { blockedRecord } = input;

  const courses =
    blockedRecord.blockedScope === BlockedRecordBlockedScope.PartialScope
      ? blockedRecord.blockedRecordCourses.map((course) => ({
          value: course.examCourse?.code ?? '',
          label: course.examCourse?.name ?? '',
        }))
      : undefined;

  return {
    blockedCourses: {
      type: blockedRecord.blockedScope,
      courses,
    },
    reason: blockedRecord.blockedReason ?? '',
  };
}

export function getStaffDefaultValues(input: {
  blockedRecord: BlockedRecord;
}): BlockedRecordStaffFormInput {
  const { blockedRecord } = input;

  const courses =
    blockedRecord.blockedScope === BlockedRecordBlockedScope.PartialScope
      ? blockedRecord.blockedRecordCourses.map((course) => ({
          value: course.examCourse?.code ?? '',
          label: course.examCourse?.name ?? '',
        }))
      : undefined;

  const enforcementEndDate = blockedRecord.metadata.enforcementEndDate
    ? new Date(blockedRecord.metadata.enforcementEndDate)
    : undefined;

  return {
    position: blockedRecord.metadata.position || undefined,
    department: blockedRecord.metadata.department || undefined,
    blockedCourses: {
      type: blockedRecord.blockedScope,
      courses,
    },
    enforcementEnd: {
      assign: blockedRecord.blockedUntil ? 'true' : 'false',
      date: enforcementEndDate,
    },
    remark: blockedRecord.blockedReason || undefined,
  };
}
export function getExamCenterManagerDefaultValues(input: {
  blockedRecord: BlockedRecord;
}): BlockedRecordExamCenterManagerFormInput {
  const { blockedRecord } = input;

  const courses =
    blockedRecord.blockedScope === BlockedRecordBlockedScope.PartialScope
      ? blockedRecord.blockedRecordCourses.map((course) => ({
          value: course.examCourse?.code ?? '',
          label: course.examCourse?.name ?? '',
        }))
      : undefined;

  const enforcementEndDate =
    blockedRecord.metadata.enforcementEndDate && blockedRecord.blockedUntil
      ? new Date(blockedRecord.metadata.enforcementEndDate)
      : undefined;

  return {
    position: blockedRecord.metadata.position || undefined,
    department: blockedRecord.metadata.department || undefined,
    blockedCourses: {
      type: blockedRecord.blockedScope,
      courses,
    },
    enforcementEnd: {
      assign: blockedRecord.blockedUntil ? 'true' : 'false',
      date: enforcementEndDate,
    },
    remark: blockedRecord.blockedReason || undefined,
  };
}

export function getExamPasserDefaultValues(input: {
  blockedRecord: BlockedRecord;
}): BlockedRecordExamPasserFormType {
  const { blockedRecord } = input;

  const blockedUntil = blockedRecord.blockedUntil
    ? new Date(blockedRecord.blockedUntil)
    : undefined;

  return {
    enforcementEnd: {
      assign: blockedRecord.blockedUntil ? 'true' : 'false',
      // Use blockedUntil instead of enforcementEndDate because Exam passer is does not have enforcementEndDate
      date: blockedUntil,
    },
    remark: blockedRecord.blockedReason || undefined,
  };
}

export function getCheaterDefaultValues(input: {
  blockedRecord: BlockedRecord;
}): BlockedRecordCheaterFormType {
  const { blockedRecord } = input;

  return {
    enforcementEnd: {
      assign: blockedRecord.blockedUntil ? 'true' : 'false',
      date: blockedRecord.blockedUntil,
    },
    remark: blockedRecord.blockedReason || undefined,
  };
}
